import api from './api'
import CallHelper from '@/helpers/call.helper'

class AmountService {
    async get(params = {}) {
        return CallHelper.getDataRecursive('/amount', params, (data, response) => {
            if(data.length) {
                data = [...data, ...response.data.amounts]
            } else {
                data = response.data.amounts
            }

            return data
        },)
    }

    async getAmountType() {
        return api.get('/enum/amount-type')
    }

    async getInstance(uuid) {
        return api.get('/amount/' + uuid)
    }

    async create(amount) {
        return api.post('/amount', amount)
        .then(response => response.data);
    }

    async modify(uuid, amount) {
        return api.patch('/amount/' + uuid, amount)
            .then(response => {
                return response.data
            })
    }

    async delete(amount) {
        return api.delete('/amount/' + amount.uuid)
            .then(response => response.data);
    }
}

export default new AmountService();
